const base = (website) => website.services.map(service => {

  if (service.show) {
    return ({
      description: service.description,
      icon: `${service.icon}/dark/48.png`,
      title: service.title,
    })
  }
});

/*
Creates an object from an array:
toButterfly([1, 2, 3, 4], 3)
returns: {
  row1: [1, 2, 3],
  row2: [4]
}
*/
const toButterfly = (servicesArray, width) =>
  servicesArray.reduce((accumulator, currentValue, index) => {
    if ((index % width) === 0){
      const rowNumber = (index/width) + 1;
      accumulator[`row${rowNumber}`] = [currentValue];
    } else {
      const rowNumber = Math.ceil(index/width);
      accumulator[`row${rowNumber}`].push(currentValue);
    }

    return accumulator;
  }, {});


const butterfly = (website) => {
  const servicesArray = website.services.map((service, index) => {
    if (service.show) {
      const iconType = `icon${ ((index % 3) + 1) }`
      return ({
        description: service.description,
        icon: `${service.icon}/light/48.png`,
        iconType: iconType,
        title: service.title,
      })
    }
  });

  return toButterfly(servicesArray, 3);
};


export const ServicesFactory = {
  getBase: base,
  getButterfly: butterfly,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/ServicesFactory.js